"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(key) {
    return new URLSearchParams(window.location.search).get(key) || undefined;
}
exports.default = default_1;
